/** @format */

export const PrintLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M26.5 12.5H5.5C3.5668 12.5 2 14.0695 2 16V21.25C2 22.2163 2.78367 23 3.75 23H5.5V28.25C5.5 29.2163 6.28367 30 7.25 30H24.75C25.7163 30 26.5 29.2163 26.5 28.25V23H28.25C29.2163 23 30 22.2163 30 21.25V16C30 14.0695 28.4305 12.5 26.5 12.5ZM23 26.5H9V21.25H23V26.5ZM25.625 18.1875C24.9004 18.1875 24.3125 17.5996 24.3125 16.875C24.3125 16.1493 24.9004 15.5625 25.625 15.5625C26.3496 15.5625 26.9375 16.1493 26.9375 16.875C26.9375 17.6023 26.3523 18.1875 25.625 18.1875ZM9 5.5H21.5508L23 6.94977V10.75H26.5V6.22461C26.5 5.76064 26.3154 5.3157 25.9873 4.98758L23.5127 2.51297C23.1859 2.18457 22.7375 2 22.2781 2H7.25C6.28422 2 5.5 2.78367 5.5 3.75V10.75H9V5.5Z"
                fill={color}
            />
        </svg>
    );
};
